import React, { useState, useMemo, useEffect }  from 'react';
import Modal from 'react-modal';
import jQuery from 'jquery';
import TextField from '@mui/material/TextField';
import { useMsal, useAccount } from "@azure/msal-react";
import { MaterialReactTable } from 'material-react-table';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html';

import * as Utils from '../lib/utils';

import CONFIG from "../config";

window.jQuery = jQuery;
require("jsgrid");

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const debounce = function(fn, ms) {
  let timer
  return _ => {
    clearTimeout(timer)
    timer = setTimeout(_ => {
      timer = null
      fn.apply(this, arguments)
    }, ms)
  };
}


const Adjustments = () => {
    const { instance, accounts, inProgress } = useMsal();
    const account = useAccount(accounts[0] || {});
    const [dimensions, setDimensions] = useState({ 
      height: window.innerHeight,
      width: window.innerWidth
    });
    
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);    
    const [rowCount, setRowCount] = useState(0);

    const [modalEmployeeListIsOpen, setEmployeeListIsOpen] = useState(false);
    const [adjustmentEmployeeList, setAdjustmentEmployeeList] = useState([]);
    const [adjustmentsData, setAdjustmentsData] = useState({});

    const [modalEmailIsOpen, setEmailIsOpen] = useState(false);
    const [emailRecipient, setEmailRecipient] = useState("");
    const [emailSubject, setEmailSubject] = useState("Compensation system request from HR");
    const [emailContents, setEmailContents] = useState("");
    const [editorState, setEditorState] = useState(
      EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML(emailContents)
        )
      )
    )
    const [currentEditorValue, setCurrentEditorValue] = useState(draftToHtml(convertToRaw(editorState.getCurrentContent())));

    const [modalPreviewIsOpen, setPreviewIsOpen] = useState(false);
    
    const urlParams = Utils.getParams();
    const effectiveDate = urlParams.effective_date;
    const eligibilityDate = urlParams.eligibility_date;
    const openDate = urlParams.open_date;
    const deadlineDate = urlParams.deadline_date;
    const adjustmentStatus = urlParams.status;

    let subtitle;

    function openEmailModal(selectedTemplateObject) {
      let thisEmail = selectedTemplateObject.body;

      setEmailRecipient(selectedTemplateObject.to);
      setEmailSubject(selectedTemplateObject.subject);
      setEmailContents(thisEmail);
      setCurrentEditorValue(selectedTemplateObject.body);
      setEditorState(
        EditorState.createWithContent(
          ContentState.createFromBlockArray(
            convertFromHTML(thisEmail)
          )
        )
      )    
      setEmailIsOpen(true);
    }
    function afterOpenEmailModal() {
      return false;
    }
    function closeEmailModal() {
      //end change change check
      setEmailIsOpen(false);
    }
    const onEditorStateChange = (editorStateEvent)=> {
      // handleEmailTemplate(editorStateEvent)
      setEditorState(editorStateEvent);
    };
      

    function openPreviewModal(adjustmentItem, managersList, status) {
      setPreviewIsOpen(true);
    }
    function afterOpenPreviewModal() {
      return false;
    }
    function closePreviewModal() {
      setPreviewIsOpen(false);
    }


    function openEmployeeListModal() {
      setEmployeeListIsOpen(true);
    }
    function afterOpenEmployeeListModal() {
      return false;
    }
    function closeEmployeeListModal() {
      setEmployeeListIsOpen(false);
    }

    
    useEffect(() => {
      const debouncedHandleResize = debounce(function handleResize() {
        setDimensions({
          height: window.innerHeight,
          width: window.innerWidth
        })
      }, 500)

      //binds a resize listener for a debounced (less frequent) resize effect
      window.addEventListener('resize', debouncedHandleResize);
      
      //unbinds listener to prevent memory leaks
      return _ => {
        window.removeEventListener('resize', debouncedHandleResize)   
      };
    });


    const fetchData = async () => {
        if (!adjustmentsData.length) {
          setIsLoading(true);
        } else {
          setIsRefetching(true);
        }
    
        try {
    
          const jsonAdjustmentsResponse = await Utils.getData(
            (
              '/api/employee_adjustment?effective_date='+effectiveDate+
                '&eligibility_date='+eligibilityDate+
                '&open_date='+openDate+
                '&deadline_date='+deadlineDate+
                '&status='+adjustmentStatus
            ), 
            instance, 
            account
          );
          setAdjustmentsData(jsonAdjustmentsResponse);
          setRowCount(jsonAdjustmentsResponse.length);
    
        } catch (error) {
          setIsError(true);
          console.error(error);
          return;
        }
    
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
    };
    
    
    useEffect(() => {
        fetchData();
    }, []);


      
    const closeAdjustmentByAdjustmentId = (adjustmentId) =>{
      if(window.confirm("Are you sure you would like to close this adjustment?")){
        Utils.postData(
          "/api/employee_adjustment/close?adjustment_id=" + adjustmentId,
          {},
          instance, 
          account
        ).then((data) => {
  
          fetchData();
  
          if(data && data.result && data.result ==="FAILED"){
            alert(data.message);
          }else{
            alert("Adjustment successfully closed");
          }
  
        });
        
      }
      return false;
    }

      
    const cellStyleHandler = (cell) => {
      // console.log("CELL", cell.row.original);
      let rowColor = "#FFF";
      if(cell.row.original.status === "Terminated"){
        rowColor = "#F66"
      }
      return ({
        sx: {
          backgroundColor: rowColor
        },
      });
    }


    //should be memoized or stable
    const columns = useMemo(
      () => [
        {
            accessorKey: 'view_adjustment',
            header: 'View Adjustment',
            muiTableBodyCellProps: ({ cell, table }) => { return cellStyleHandler(cell, table); },
            Cell: ({ cell, row }) => {
                return <div><a href={'/compensation?adjustmentId='+ row.original.id + (adjustmentStatus !== "pending" ? "&status="+adjustmentStatus+"&effectiveDate="+effectiveDate : "")}>View</a></div>
            },
            enableEditing: false,
            columnDefType: 'display',
            enablePinning: false
        },
        {
            accessorFn: (row)=>`${Utils.decodeHTML(row.last_name) + ', ' + Utils.decodeHTML(row.first_name)}`,
            header: 'Employee',
            muiTableBodyCellProps: ({ cell, table }) => { return cellStyleHandler(cell, table); },
            enableEditing: false
        },
        {
            accessorFn: (row)=>`${
              Utils.decodeHTML(row.manager_last_name) + ', ' + Utils.decodeHTML(row.manager_first_name)
            }`,
            header: 'Manager',
            muiTableBodyCellProps: ({ cell, table }) => { return cellStyleHandler(cell, table); },
            Cell: ({ cell, row }) => {
              return <div>
                  <a href={
                    '/compensation?managerHrisId='+ row.original.manager_hris_id + (adjustmentStatus !== "pending" ? "&status="+adjustmentStatus+"&effectiveDate="+effectiveDate : "")}>
                    {
                      Utils.decodeHTML(row.original.manager_last_name) + ', ' + 
                      Utils.decodeHTML(row.original.manager_first_name)
                    }
                  </a>
                </div>
            },            
            enableEditing: false
        },
        {
            accessorFn: (row)=>`${
              Utils.decodeHTML(row.approver_last_name) + ', ' + Utils.decodeHTML(row.approver_first_name)
            }`,
            header: 'Approver',
            muiTableBodyCellProps: ({ cell, table }) => { return cellStyleHandler(cell, table); },
            Cell: ({ cell, row }) => {
              return <div>
                  <a href={
                    '/compensation?managerHrisId='+ row.original.approver_hris_id + (adjustmentStatus === "approved" ? "&status=approved" : "")}>
                    {
                      Utils.decodeHTML(row.original.approver_last_name) + ', ' + 
                      Utils.decodeHTML(row.original.approver_first_name)
                    }
                  </a>
                </div>
            },            
            enableEditing: false
        },
        {
          header: 'Close',
          muiTableBodyCellProps: ({ cell, table }) => { return cellStyleHandler(cell, table); },
          Cell: ({ cell, row }) => {
            return <div>
                <a href="#" onClick={(event)=>{
                  closeAdjustmentByAdjustmentId(row.original.id)
                  return false;
                }}>Close</a>
              </div>;
          },            
          enableEditing: false
      },
      ],
      [],
    );


    const tableHeightValue =  window.innerHeight > 183 ? window.innerHeight - 183 : 300;
    const tableHeightCSS = tableHeightValue + "px";

    return <div>
        <Modal
          portalClassName={"ReactModalPortal emailOverlay"}
          isOpen={modalEmailIsOpen}
          onAfterOpen={afterOpenEmailModal}
          onRequestClose={closeEmailModal}
          style={modalStyles}
          contentLabel="Send Emails"
          ariaHideApp={false} // ignores need for "Modal.setAppElement('#yourAppElement');"
        >
          <h2 className="modalTitle" ref={(_subtitle) => (subtitle = _subtitle)}>
            Send compensation email to managers
          </h2>
          <div className="modalBody">
            Recipient: 
            <TextField 
              type="text" 
              name="emailRecipient" 
              id="emailRecipient" 
              className="emailRecipientInput" 
              value={emailRecipient} 
              fullWidth={true}
              onChange={(event)=>{setEmailRecipient(event.target.value);}}
            />

            Subject: 
            <TextField 
              type="text" 
              name="emailSubject" 
              id="emailSubject" 
              className="emailSubjectInput" 
              value={emailSubject} 
              fullWidth={true}
              onChange={(event)=>{setEmailSubject(event.target.value);}}
            />

            <Editor
              id="emailContents"
              editorState={editorState}
              wrapperClassName="hr-editor-wrapper"
              editorClassName="hr-editor-input"
              onEditorStateChange={onEditorStateChange}
            />
            
          </div>
          <div className="modalFooter">
            {/* <button className="btn btn-primary" onClick={()=>{
              // saveEmailTemplate();
              return false;
            }}>Save Template</button> */}

            <button className="btn btn-primary" onClick={()=>{
              openPreviewModal();
              return false;
            }}>Preview Email</button>

            &nbsp;&nbsp;&nbsp;
          
            <button className="btn btn-primary" onClick={()=>{
              // console.log("SEND THE EMAILS")

              Utils.postData(
                "/api/emailer",
                {
                  recipient : emailRecipient,
                  subject : emailSubject,
                  message : draftToHtml(convertToRaw(editorState.getCurrentContent()))
                },
                instance, 
                account
              ).then((data) => {
        
                alert(data.message);
                closeEmailModal();
        
              });

              return false;
            }}>Send Emails</button>
            
            <button className="btn btn-primary" onClick={closeEmailModal}>Cancel</button>
          
          </div>
        </Modal> 

        <Modal
          portalClassName={"ReactModalPortal previewOverlay"}
          isOpen={modalPreviewIsOpen}
          onAfterOpen={afterOpenPreviewModal}
          onRequestClose={closePreviewModal}
          style={modalStyles}
          contentLabel="Preview email"
          ariaHideApp={false} // ignores need for "Modal.setAppElement('#yourAppElement');"
        >
          <h2 className="modalTitle" ref={(_subtitle) => (subtitle = _subtitle)}>
            Email Preview
          </h2>
          <div className="modalBody previewEmailBlock">
          
            <Editor 
              toolbarHidden
              editorState={
                EditorState.createWithContent(
                  ContentState.createFromBlockArray(
                    convertFromHTML(
                      draftToHtml(
                        convertToRaw(
                          editorState.getCurrentContent()
                        )
                      )
                      // .replace(/#COMPENSATIONLINK#/g, 
                      //   sampleUrl+
                      //   (adjustmentStatus==="approved"?("&effectiveDate="+(activeAdjustment?activeAdjustment.effective_date:"")):"")
                      // )
                    )
                  )
                )
              } 
              readOnly={true} 
            /> 
          </div>
          <div className="modalFooter">
            <button className="btn btn-primary" onClick={closePreviewModal}>Close</button>
          </div>
        </Modal>         

        <Modal
          isOpen={modalEmployeeListIsOpen}
          onAfterOpen={afterOpenEmployeeListModal}
          onRequestClose={closeEmployeeListModal}
          style={modalStyles}
          contentLabel="Adjustment Employees"
          ariaHideApp={false} // ignores need for "Modal.setAppElement('#yourAppElement');"
        >
          <h2 className="modalTitle" ref={(_subtitle) => (subtitle = _subtitle)}>
            Viewing Adjustment Employees
          </h2>
          <div className="modalBody" style={{ maxHeight: "300px", overflowY: "scroll" }}>
            {adjustmentEmployeeList.map((employeeItem)=>{
              return <div key={Utils.guid()}>
                <span>{Utils.decodeHTML(employeeItem.last_name)}, {Utils.decodeHTML(employeeItem.first_name)}</span>
              </div>
            })}
          </div>
          <div className="modalFooter">
            <button className="btn btn-primary" onClick={closeEmployeeListModal}>Close</button>
          </div>
        </Modal> 
          
        <MaterialReactTable 
          renderTopToolbarCustomActions={({ table }) => {
            return <div>
              <span className="sectionTableHeader">
                {adjustmentStatus ==="review" ? "Submitted" : Utils.capitalizeFirstLetter(adjustmentStatus)} Adjustments Effective {effectiveDate}
              </span>
              &nbsp;&nbsp;&nbsp;
              <button className="btn btn-primary" style={{ margin : "-5px 0px 5px 20px" }} onClick={(e)=>{
                e.preventDefault();
                
                const selectedRowsData = table.getSelectedRowModel().flatRows.map((row) => row.original);

                if(selectedRowsData.length){
                  let emailRecipient = "";
                  let emailSubject = "";
                  let emailTemplate = "";

                  // console.log("adjustmentStatus", adjustmentStatus);
                  // console.log("SEND REMINDERS!", selectedRowsData);
                  // console.log("CONFIG", CONFIG);

                  if(adjustmentStatus === "pending"){
                    emailRecipient = selectedRowsData[0].manager_email;
                    emailSubject = "Reminder: Please submit compensation adjustments";
                    emailTemplate = `Dear ${selectedRowsData[0].manager_first_name} ${selectedRowsData[0].manager_last_name},<br /><br />`+
                      `The following employees have not had their compensation requests submitted:<br />`+
                      selectedRowsData.map((rowData)=>{ 
                        return `${rowData.first_name} ${rowData.last_name}<br />` 
                      }).join("")+
                      `<br />You may access ECS at the following link to submit your team members adjustments: `+
                      `<a href="${CONFIG.HOST_URL}">ECS - Employee Compensation System</a>`;
                  }
                  if(adjustmentStatus === "review"){
                    emailRecipient = selectedRowsData[0].approver_email;
                    emailSubject = "Reminder: Please approve compensation adjustments";
                    emailTemplate = `Dear ${selectedRowsData[0].approver_first_name} ${selectedRowsData[0].approver_last_name},<br /><br />`+
                      `The following employees have not had their compensation requests approved:<br />`+
                      selectedRowsData.map((rowData)=>{ 
                        return `${rowData.first_name} ${rowData.last_name}<br />` 
                      }).join("")+
                      `<br />You may access ECS at the following link to submit your team members adjustments: `+
                      `<a href="${CONFIG.HOST_URL}">ECS - Employee Compensation System</a>`;
                  }

                  openEmailModal({
                    subject : emailSubject,
                    body : emailTemplate,
                    to: emailRecipient
                  });
                }else{
                  window.alert("No employees have been selected")
                }

                return false;
              }}>Send Reminder Email</button>
            </div>
          }} 
          layoutMode='grid'
          displayColumnDefOptions={{
              'mrt-row-select': { 
                size: 50, // Set the width (e.g., to 50px)
              },
          }}
          columns={columns} 
          data={adjustmentsData}
          globalFilterFn="contains" 
          positionToolbarAlertBanner="none"
          enableStickyHeader
          enableRowSelection
          muiToolbarAlertBannerProps={
            isError
              ? {
                  color: 'error',
                  children: 'Error loading data',
                }
              : undefined
          }
          renderBottomToolbarCustomActions={({ table }) => {
            return <div style={{"marginTop":"-15px", "fontSize":"10pt", "fontWeight":"bold"}}>
              <div style={{ backgroundColor:"#F66" }}>Red employees have left the company, however an adjustment was created for them prior to leaving.</div>
            </div>
          }}
          muiTableContainerProps={{ sx: { height: tableHeightCSS } }}
          rowCount={rowCount}
          editDisplayMode="row"
          // onEditingRowSave={handleSaveRow}        
          state={{
            isLoading,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            tableData: adjustmentsData
          }}
        />
      </div>;
};

export default Adjustments;